import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { DropdownMobile, errorCatch, GET, JSXMap, updateInArray, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import { Collapse } from 'antd-mobile';
import Markdown from 'markdown-to-jsx';


export default function ReportVoprosiSudeiskikhAttestatsii(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	let navigate = useNavigate();

	const { auth } = props;
	const { id } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/voprosisudeiskikhattestatsii/report/${id}`, ({ data }) => {
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)

	return (
		<div>
			<div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
				<ReactToPrint
					trigger={() => {
						// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
						// to the root node of the returned component as it will be overwritten.
						return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
					}}
					content={() => ref.current}
				/>
			</div>
			{(!!data?.ID) && <div className="report" style={{ padding: "0 25px" }} ref={ref}>
				<div style={{ paddingBottom: "15px" }}>
					<div style={{ fontSize: "16px" }}>
						<Markdown className="md mw400">
							{(data?.tekstVoprosa) ? "🔹" + data?.tekstVoprosa : ""}
						</Markdown>
					</div>
					<div style={{ paddingLeft: "15px", fontSize: "14px" }}>
						{JSXMap(data?.variantiOtvetovVopros, (otvet, cidx1) => {
							return (<div key={cidx1} style={{ display: "flex", gap: "10px" }}>
								<div style={{ flex: "0 0", padding: "0 5px", backgroundColor: (!!otvet.flag) ? "yellow" : "" }}>{cidx1 + 1}</div>
								<Markdown className="md mw400">
									{(otvet?.tekst) ? otvet?.tekst : ""}
								</Markdown>
							</div>)
						})}
					</div>
					<div style={{ paddingLeft: "15px", fontSize: "14px", borderLeft: "1px solid gray", marginLeft: "24px", marginTop: "5px" }}>
						{JSXMap(data?.parametriVoprosaVopros, (param, cidx1) => {
							return (<div key={cidx1} style={{ fontSize: "12px", fontStyle: "italic" }}>
								Категория судей: {param?.kategoriyaSudei?.nazvanieKategorii}, ценность вопроса: {Math.round((param?.tsennostVoprosa || 0) * 100) / 100}
							</div>)
						})}
					</div>
				</div>
			</div>}
		</div >);

}
